import { render, staticRenderFns } from "./DefaultIndexPage.vue?vue&type=template&id=68514b52&scoped=true"
import script from "./DefaultIndexPage.vue?vue&type=script&lang=js"
export * from "./DefaultIndexPage.vue?vue&type=script&lang=js"
import style0 from "./DefaultIndexPage.vue?vue&type=style&index=0&id=68514b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68514b52",
  null
  
)

export default component.exports